import { MutableRefObject, useLayoutEffect, useState } from 'react';

const useIsOverflow = (ref: MutableRefObject<HTMLElement | null>) => {
  const [isOverflow, setIsOverflow] = useState<boolean | undefined>(undefined);

  useLayoutEffect(() => {
    const { current } = ref;
    if (!current) {
      return;
    }

    const trigger = () => {
      const hasOverflow = current.scrollHeight > current.clientHeight;
      setIsOverflow(hasOverflow);
    };

    if (current) {
      trigger();
    }
  }, [ref]);

  return isOverflow;
};

export default useIsOverflow;
